<div class ="wrapper" width="100%" height="100%">
    <gridster #gridster [options]="options" width="100%" height="100%" class="gridster" tabindex="0" 
    [style.background-color]="_backgroundColor" ><!--style="overflow: hidden !important;"-->
      <gridster-item [item]="item" *ngFor="let item of widgets" >
        <freegridster-item 
            [model]="model"
            [field]="item" 
            [templatingMode]="templatingMode"
            (delete)="onItemDeleted($event)"></freegridster-item>
      </gridster-item>
    </gridster>
  </div>